<template>
  <div class="row-container">
    <TextField v-model="item.quantity" type="number" :min="1" name="quantity" no-label class="number-input mr-3" />
    <Select v-model="cadenceModel" :options="cadenceOptions" :allow-empty="false" name="cadence" no-label
      placeholder="Select cadence" :field-error="firstErrorMessage(v$.cadenceModel)" class="cadence-select mr-2"
      data-cy="cadenceSelect" />
    <Tooltip v-if="taskTooltipText">
      <template #trigger>
        <i class="fas fa-question-circle text-blue mr-3"></i>
      </template>
      <template #tooltip>
        <span>{{ taskTooltipText }}</span>
      </template>
    </Tooltip>
    <div class="flex-1 mb-1 label unit-name">{{ item.unit_name }}</div>
    <i class="fas fa-trash-alt thumbnail-trash ml-3 link" @click="$emit('delete-item', item.item_id)"></i>
  </div>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue";
import TextField from "@/components/TextField.vue";
import CONSTANTS from "@/Constants.js";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  components: {
    TextField,
    Tooltip
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["delete-item"],
  setup() {
    return {
      v$: useVuelidate(),
      firstErrorMessage
    };
  },
  data() {
    return {
      cadenceOptions: CONSTANTS.BENEFIT_CADENCES
    };
  },
  computed: {
    cadenceModel: {
      get() {
        const known = CONSTANTS.BENEFIT_CADENCES.some(
          (option) => option.value === this.item.cadence
        );
        return known ? this.item.cadence : null;
      },
      set(value) {
        this.item.cadence = value;
      }
    },
    cadenceMonths() {
      const option = CONSTANTS.BENEFIT_CADENCES.find(
        (o) => o.value === this.item.cadence
      );
      return option ? option.months : null;
    },
    taskTooltipText() {
      const qty = Number(this.item.quantity);
      const months = this.cadenceMonths;
      if (!Number.isFinite(qty) || qty < 1 || !months) return "";
      const taskLabel = qty === 1 ? "task" : "tasks";
      const monthLabel = months === 1 ? "month" : "months";
      return `${qty} ${taskLabel} available every ${months} ${monthLabel} from a member's start date.`;
    }
  },
  validations() {
    return {
      cadenceModel: { required, $autoDirty: true }
    };
  }
};
</script>

<style>
.row-container {
  display: flex;
  flex-grow: 1;
  color: var(--darkblue);
  align-items: baseline;
}

.thumbnail-trash {
  font-size: 18px;
  margin-top: 0.5rem;
}

.number-input {
  width: 60px;
  min-width: 60px;
}

.cadence-select {
  width: 140px;
  min-width: 140px;
}

.unit-name {
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0.3rem;
}
</style>
